import { Breadcrumb } from 'antd';
import { useTranslation } from 'react-i18next';

import { ContentHeader, DefaultLayout } from '@/component';
import { List } from '@/views/brand/list/List';

export const BrandListPage = () => {
  const { t } = useTranslation(['brandInfo']);

  return (
    <DefaultLayout>
      <DefaultLayout.Header>
        <Breadcrumb>
          <Breadcrumb.Item>{t('brandInfo:rootMenu')}</Breadcrumb.Item>
          <Breadcrumb.Item>{t('brandInfo:listPage.title')}</Breadcrumb.Item>
        </Breadcrumb>
      </DefaultLayout.Header>
      <DefaultLayout.Content>
        <ContentHeader title={t('brandInfo:listPage.title')} />
        <List />
      </DefaultLayout.Content>
    </DefaultLayout>
  );
};
